import { gql } from '@apollo/client';

export const TALENT_SHARED_FIELDS_FRAGMENT = gql`
    fragment TalentFragment on Talent {
        _id
        slug
        fullName
        firstName
        lastName
        gender
        postalCode
        address
        email
        city
        logo
        photo
        active
        yearsOfExperience
        hasInvalidExperiences
        RBA_percentage
        upercutAverageRating
        currentStatusUser
        roleDescription
        isActiveStatusUser
        profileCompletionRate
        completedProfileSections
        jobOfferScoring
        jobOfferScoringStatus
        jobOfferScoringExplainer
        expectedSalary
        preferences
        degree
        principalProfession
        professions
        createdAt
        totalApplications
        totalApplications
        profilePicture {
            url
        }
        profileBanner {
            url
        }
        upercutRatings {
            _id
            upercutId
            rating
            createdAt
        }
        upercutNotes {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
        upercutFavorites {
            _id
            talentId
            type
            metadata {
                notes
                tags
                priority
                campaign
            }
            createdAt
        }
        createdAt
        resume {
            path
            name
            mimetype
        }
        resumeId
        files {
            _id
            name
            path
            context
            size
            url
            mimetype
        }
        jobApplications {
            _id
            source
            status
            subStatus
            date
            resumeScore
            rating
            type
            jobOffer {
                title
                city
                brand {
                    brandName
                    brandLogo {
                        url
                    }
                }
            }
        }
        experiences {
            _id
            title
        }
        diplomas {
            _id
            title
            type
        }
        certificates {
            _id
            title
        }
    }
`;

export const GET_TALENTS = gql`
    query GetAllActiveTalents($pagination: Pagination, $query: String, $filter: TalentFilter, $sortBy: TalentSortBy) {
        getTalentsUpercut(pagination: $pagination, query: $query, filter: $filter, sortBy: $sortBy) {
            docs {
                ...TalentFragment
            }
            meta {
                totalDocs
                limit
                page
                totalPages
                hasPrevPage
                hasNextPage
            }
        }
    }

    ${TALENT_SHARED_FIELDS_FRAGMENT}
`;

export const TOGGLE_TALENT_ACTIVE_STATUS = gql`
    mutation ToggleTalentActiveStatus($talentId: ID!) {
        toggleTalentActiveStatus(talentId: $talentId) {
            _id
            active
            email
            fullName
            isActiveStatusUser
        }
    }
`;

export const DELETE_TALENT_UPERCUT = gql`
    mutation DeleteTalentUpercut($talentId: ID!) {
        deleteTalentUpercut(talentId: $talentId) {
            _id
        }
    }
`;

export const DOWNLOAD_FILE = gql`
    query DownloadFile($_id: ID, $url: String) {
        downloadFile(_id: $_id, url: $url) {
            url
        }
    }
`;

export const UPDATE_TALENT_RATING = gql`
    mutation UpdateTalentRatingUpercut($rating: Float!, $talentIds: [ID!]!) {
        updateTalentRatingUpercut(rating: $rating, talentIds: $talentIds) {
            _id
            upercutAverageRating
            upercutRatings {
                _id
                upercutId
                rating
                createdAt
            }
        }
    }
`;

export const UPDATE_TALENT_STATUS = gql`
    mutation UpdateStatusUsersUpercut($payload: InputStatusUserUpercut!) {
        updateStatusUsersUpercut(payload: $payload) {
            _id
            currentStatusUser
        }
    }
`;

export const GET_TALENT = gql`
    query GetTalent($talentId: ID!) {
        getTalent(talentId: $talentId) {
            ...TalentFragment
            bio
            phoneNumber
            countryCode
            rating
            currentSalary
            softSkills
            social {
                instagram
                linkedin
                website
            }
            experiences {
                _id
                title
                enterprise {
                    _id
                    name
                }
                description
                profession {
                    _id
                    name
                }
                sector {
                    _id
                    sectorName
                }
                type
                specialties {
                    _id
                    name
                }
                city
                country
                startDate
                endDate
                numberOfMonths
                current
            }
            majors
            softSkillIds
            files {
                _id
                name
                path
                context
                size
                url
                mimetype
            }
            diplomas {
                _id
                title
                current
                description
                school {
                    _id
                    name
                }
                type
                result
                city
                profession {
                    _id
                    name
                }
                startDate
                endDate
                file {
                    _id
                    name
                    path
                    context
                    size
                    url
                    mimetype
                }
            }
            certificates {
                _id
                title
                issuer {
                    _id
                    name
                }
                number
                obtainedResult
                url
                profession {
                    _id
                    name
                }
                file {
                    _id
                    name
                    path
                    context
                    size
                    url
                    mimetype
                }
                startDate
                endDate
                current
            }
             talentLanguages {
                _id
                languages {
                    level {
                        _id
                        level
                        score
                    }
                    language {
                        _id
                        code
                        original_letter
                        name
                    }
                    certificates {
                        _id
                        title
                        number
                        url
                        startDate
                        endDate
                        obtainedResult
                        issuer {
                            _id
                            name
                        }
                        file {
                            _id
                            name
                            path
                            context
                            size
                            url
                            mimetype
                        }
                    }
                }
            }
        }
    }

    ${TALENT_SHARED_FIELDS_FRAGMENT}
`;

export const UPDATE_ADMINISTRATIVE_TALENT = gql`
    mutation($payload: InputAdministrativeTalent!, $talentId: ID) {
        updateAdministrativeTalent(payload: $payload, talentId: $talentId) {
            _id
        }
    }
`;

export const UPDATE_PREFERENCES_TALENT = gql`
    mutation($payload: InputPreferenceTalent!, $talentId: ID) {
        updatePreferencesTalent(payload: $payload, talentId: $talentId) {
            _id
        }
    }
`;

export const UPDATE_PREFERED_SALARY_TALENT = gql`
    mutation($payload: InputPreferedSalaryTalent!, $talentId: ID) {
        updatePreferedSalaryTalent(payload: $payload, talentId: $talentId) {
            _id
            currentSalary
            expectedSalary
        }
    }
`;

export const UPDATE_SOFT_SKILLS_TALENT = gql`
    mutation($payload: InputSoftSkillTalent!, $talentId: ID) {
        updateSoftSkillsTalent(payload: $payload, talentId: $talentId) {
            _id
        }
    }
`;

export const UPDATE_GEOGRAPHY_MOBILITY_TALENT = gql`
    mutation($payload: InputGeographyMobilityTalent!, $talentId: ID) {
        updateGeographyMobilityTalent(payload: $payload, talentId: $talentId) {
            _id
        }
    }
`;

export const UPDATE_CONTACTS_TALENT = gql`
    mutation($payload: InputUpdateContactsTalent!, $talentId: ID) {
        updateContactsTalent(payload: $payload, talentId: $talentId) {
            _id
            email
            phoneNumber
            social {
                instagram
                linkedin
                website
            }
        }
    }
`;

export const UPDATE_STATUS_USER_TALENT = gql`
    mutation UpdateStatusUser($payload: InputStatusUser) {
        updateStatusUser(payload: $payload) {
            _id
            currentStatusUser
        }
    }
`;

// Talent Notes Operations
export const GET_TALENT_NOTES = gql`
    query GetTalentNotesUpercut($talentId: ID!) {
        getTalentNotesUpercut(talentId: $talentId) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const CREATE_TALENT_NOTE = gql`
    mutation CreateTalentNoteUpercut($talentId: ID!, $input: InputUpercutNote!) {
        createTalentNoteUpercut(talentId: $talentId, input: $input) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const UPDATE_TALENT_NOTE = gql`
    mutation UpdateTalentNoteUpercut($talentId: ID!, $noteId: ID!, $input: InputUpercutNote!) {
        updateTalentNoteUpercut(talentId: $talentId, noteId: $noteId, input: $input) {
            _id
            upercutId
            note
            title
            visibility
            createdAt
        }
    }
`;

export const DELETE_TALENT_NOTE = gql`
    mutation DeleteTalentNoteUpercut($talentId: ID!, $noteId: ID!) {
        deleteTalentNoteUpercut(talentId: $talentId, noteId: $noteId)
    }
`;

export const UPDATE_BANNER_TALENT = gql`
    mutation UpdateBannerTalent($talentId: ID, $file: Upload!) {
        updateBannerTalent(talentId: $talentId, file: $file)
    }
`;

export const UPDATE_PROFILE_PICTURE_TALENT = gql`
    mutation UpdateProfilePictureTalent($talentId: ID, $file: Upload!) {
        updateProfilePictureTalent(talentId: $talentId, file: $file)
    }
`;
